module.exports = __webpack_public_path__ + "img/jeronimos.3ab8e653.jpg";